export default "__VITE_PUBLIC_ASSET__84746688__"